/**
 * ISSUE: Warning: findDOMNode is deprecated in StrictMode. >> React 18
 * ISSUE: Type error: Property 'findDOMNode' does not exist on type typeof >> React 19+
 *
 * This code was borrowed from: react-restart repository to solve an issue with react-transition-group where
 *
 * @see https://github.com/react-bootstrap/react-bootstrap/issues/5075#issuecomment-850127642
 * @see https://github.com/react-bootstrap/react-bootstrap/pull/5687/files
 * @link https://github.com/react-restart/hooks/blob/master/src/useMergedRefs.ts
 * */

import React, { useCallback, useRef } from 'react';
import Transition, { TransitionProps, TransitionStatus } from 'react-transition-group/Transition';
import useMergedRefs from './useMergedRefs';

export type TransitionWrapperProps = TransitionProps & {
  childRef?: React.Ref<unknown>;
  children: React.ReactElement | ((status: TransitionStatus, props: Record<string, unknown>) => React.ReactNode);
};

// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = React.forwardRef<Transition<any>, TransitionWrapperProps>(
  (
    { onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children, childRef, ...props },
    ref
  ) => {
    const nodeRef = useRef<HTMLElement>(null);
    const mergedRef = useMergedRefs(nodeRef, childRef);

    const attachRef = (r: React.ComponentClass | Element | null | undefined) => {
      mergedRef(r as any);
    };

    const normalize = (callback?: (node: HTMLElement, param: unknown) => void) => (param: unknown) => {
      if (callback && nodeRef.current) {
        callback(nodeRef.current, param);
      }
    };

    // eslint-disable-next-line
    const handleEnter = useCallback(normalize(onEnter as any), [onEnter]);
    // eslint-disable-next-line
    const handleEntering = useCallback(normalize(onEntering as any), [onEntering]);
    // eslint-disable-next-line
    const handleEntered = useCallback(normalize(onEntered as any), [onEntered]);
    // eslint-disable-next-line
    const handleExit = useCallback(normalize(onExit), [onExit]);
    // eslint-disable-next-line
    const handleExiting = useCallback(normalize(onExiting), [onExiting]);
    // eslint-disable-next-line
    const handleExited = useCallback(normalize(onExited), [onExited]);
    // eslint-disable-next-line
    const handleAddEndListener = useCallback(normalize(addEndListener as any), [addEndListener]);

    return (
      <Transition
        ref={ref}
        {...props}
        onEnter={handleEnter}
        onEntered={handleEntered}
        onEntering={handleEntering}
        onExit={handleExit}
        onExited={handleExited}
        onExiting={handleExiting}
        addEndListener={handleAddEndListener}
        nodeRef={nodeRef}
      >
        {/*@ts-ignore*/}
        {typeof children === 'function'
          ? (status: TransitionStatus, innerProps: Record<string, unknown>) =>
              children(status, {
                ...innerProps,
                ref: attachRef,
              })
          : React.cloneElement(children as React.ReactElement, {
              // ref: attachRef,
            })}
      </Transition>
    );
  }
);

TransitionWrapper.displayName = 'TransitionWrapper';

export default TransitionWrapper;
